import { EventBus } from '@/event-bus.js'

const state = {
  table: ''
}

const getters = {
  table: state => state.table
}

const mutations = {
  SET_TABLE (state, table) {
    state.table = table
    EventBus.$emit('TableChanged', table)
  }
}

const actions = {
  SetTable ({
    commit
  }, table) {
    commit('SET_TABLE', table)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
